import { useState } from 'react'
import { CheckboxField } from '@/form-control/fields'
import ROUTES from '@/ROUTES'
import { usePaywallModal } from '@/stripe/PayWallModal'
import { usePaywall } from '@/stripe/PayWallProvider'

import { ITask } from '@/MODELS/roadmapStep.model'

import analytics from '@/services/analytics.service'
import { api } from '@/services/api.service'

export function TaskCheckbox({
    task,
    stepId,
    refresh,
    isDashboard,
}: {
    task: ITask
    stepId: string
    refresh: () => void
    isDashboard?: boolean
}) {
    const { hasAccess, refreshUsageStatus } = usePaywall()
    const [showDescription, setShowDescription] = useState(false)

    const { showSubscriptionModal } = usePaywallModal()
    function handleTaskToggle(taskId: string, checked: boolean) {
        if (!hasAccess) {
            showSubscriptionModal()
            return
        }
        // Track the task toggle
        analytics.trackChecklistTaskToggle(taskId, checked, stepId, task?.task)

        api(ROUTES.app.checkTask, { stepId: stepId, taskId: taskId, checked: checked }).then(async () => {
            refresh()
            // Re-check usage status — completing a task may complete a milestone and cross the threshold
            const status = await refreshUsageStatus()
            if (status?.thresholdReached && !hasAccess) {
                showSubscriptionModal()
            }
        })
    }

    return (
        <div
            onClick={(e) => e.stopPropagation()}
            className='flex items-start px-3 py-0.5 space-x-3 transition-colors rounded-lg hover:bg-gray-50 group'
        >
            <div className='relative mt-0.5'>
                <CheckboxField
                    inputClass='w-5 h-5'
                    value={task?.isChecked}
                    onChange={(val) => handleTaskToggle(task?._id, val)}
                    display='inline'
                />
            </div>
            <div className='flex-1'>
                <div
                    className={`
                        text-sm font-medium transition-all duration-200
                        ${task?.isChecked ? 'text-gray-400 line-through' : 'text-gray-700 group-hover:text-gray-900'} ${isDashboard ? 'mt-2' : ''}
                    `}
                >
                    {task?.task}
                </div>
                {task?.description && !isDashboard && (
                    showDescription ? (
                        <>
                            <div
                                className={`text-xs transition-all duration-200 ${task?.isChecked ? 'text-gray-300 line-through' : 'text-gray-500'}`}
                            >
                                {task?.description}
                            </div>
                            <button onClick={() => setShowDescription(false)} className='text-xs text-brand-500 hover:text-brand-600 mt-0.5'>
                                Show less
                            </button>
                        </>
                    ) : (
                        <button onClick={() => setShowDescription(true)} className='text-xs text-brand-500 hover:text-brand-600 mt-0.5'>
                            Show more
                        </button>
                    )
                )}
            </div>
        </div>
    )
}
